var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-cache',{ref:"cache",attrs:{"get-data":_vm.getItem,"id":_vm.id},scopedSlots:_vm._u([{key:"default",fn:function({data}){return _c('CommonConfig',{attrs:{"owner-id-prop":data.ownerId,"owner-type-prop":data.ownerType,"status-prop":data.status}})}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }